import { useState } from 'react'
import { RefreshButtonProps } from './types'

export default function useRefresh( refetchFunction: RefreshButtonProps['refetchFunction'] ) {
	const [ isSpinning, setIsSpinning ] = useState( false )

	const onClick = async() => {
		setIsSpinning( true )
		await refetchFunction()
		setIsSpinning( false )
	}

	return { isSpinning, onClick }
}
